var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKontaktWoman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 359.29 364.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffa273;\n      }\n\n      .cls-2 {\n        fill: #ffb087;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #7c89e6;\n      }\n\n      .cls-5 {\n        fill: #73617a;\n      }\n\n      .cls-6 {\n        fill: #412233;\n      }\n\n      .cls-7 {\n        fill: #707ccf;\n      }\n\n      .cls-8 {\n        fill: #44b8fa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 235.63,
    y: 254.22,
    width: 8.01,
    height: 110.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "265.86 254.22 0 254.22 0 83.78 219.66 83.78 265.86 254.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "210.63 231.23 48.35 231.23 48.15 230.43 13.12 84.94 15.15 84.45 49.99 229.15 210.63 229.15 210.63 231.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m234.91,153.22c-9.23,8.02-23.21,7.03-31.23-2.2l-29.21-33.41-2.54-2.9-25.4-29.05c-8.02-9.23-7.03-23.21,2.2-31.23,4.19-3.64,9.37-5.43,14.52-5.43s10.18,1.75,14.26,5.21c.88.72,1.7,1.54,2.47,2.42l14.33,16.38,42.82,48.99c8.02,9.23,7.03,23.21-2.21,31.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m321.75,128.64l-18.36,26.62c-1.53,2.23-4.68,2.69-6.81.9-1.51-1.27-1.94-3.35-1.3-5.15.14-.41.34-.8.59-1.17.65-.94.06-2.24-1.08-2.37l-16.82-1.85-1.77-.19-.6-.07,3.16-28.72,5.81.64,1.88.2,2.18.24s11.37,1.26,13.08,1.44l6.03.67c13.62,1.33,15.37,6.84,14,8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m277.55,145.57s-3.31.34-8.57.81c-15.98,1.46-49.92,4.22-62.98,2.78-14.25-1.57-20.93-12.27-19.59-24.43.19-1.73.57-3.39,1.13-4.96,3.33-9.45,12.8-15.72,23.19-14.64.04,0,.08.01.12.01l69.86,11.7-3.15,28.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m277.55,145.57s-3.31.34-8.57.81c-7.64-3.84-17.73-8.79-30.18-14.59-16.67-7.76-24.45-18.43-28.08-26.66.04,0,.08.01.12.01l69.86,11.7-3.15,28.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m319.61,263.21l-47.17,30.5s-51.85-55.05-78.13-85.77c-3.93-4.58-7.52-8.87-10.73-12.92-13.52-17.04-20.26-29.88-16.28-43.16,1.4-4.7,4.14-9.45,8.39-14.46.43-.5.87-1,1.32-1.48,4.31-4.65,9.33-8.09,14.72-10.37l.09-.04c10.47-4.38,22.29-4.38,32.79-.38,9.25,3.5,17.49,10.12,22.91,19.53l72.08,118.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m359.29,269.09l-72.47,46.86-14.38-22.24,47.17-30.49s14.16,4.27,24.28.07c9.19-3.81,15.41,5.81,15.41,5.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m246.87,223.52l-31.25,87.05-9.93,27.66h-56.17l13.17-117.52c-4.65-16.98,1.07-33.83,12.7-44.68,7.91-7.37,18.55-11.98,30.51-11.98.66,0,1.32.01,1.97.05,29.55,1.28,48.98,31.57,38.99,59.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m233.21,364.72h-86.3l2.62-26.49h56.17s8.46,11.27,19.04,13.24c9.61,1.79,8.47,13.24,8.47,13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m173.66,51.16c5.37-11.48,10.84-48.62-1.65-50.79-10.08-1.75-30.45,2.6-43.96,14.1-11.87,10.11-.88,32.92-40.71,34.68-39.83,1.76-54.29,52.54,1.43,59.95,41.83,5.56,70.63-27.45,84.89-57.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m125.69,84.79l-38.05,31.31-15.59,12.84-13.4,11.03c-9.41,7.8-23.38,6.5-31.18-2.92-7.8-9.42-6.49-23.38,2.92-31.18l43.27-35.62,18.33-15.1,5.43-4.47c2.16-1.8,4.57-3.11,7.09-3.95.02,0,.05-.02.06-.02,2.26-.76,4.62-1.13,6.96-1.13.09,0,.18,0,.27,0,6.27.07,12.47,2.79,16.8,8.01,7.8,9.41,6.49,23.37-2.92,31.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m183.53,77.56l-6.79,30-2.27,10.05-10.51,46.44H63.85l8.2-35.12,7.67-32.87,7.09-30.34c.93-3.98,2.74-7.56,5.19-10.56,3.24-3.96,7.58-6.91,12.52-8.42.03,0,.05-.02.07-.02,2.3-.7,4.73-1.09,7.23-1.12.12,0,.23,0,.35,0h46.01c.38,0,.75,0,1.13.02,7.31.31,13.72,3.6,18.2,8.58,5.46,6.05,8.07,14.6,6.03,23.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "111.98 78.32 92.99 89.19 105.91 135.48 104.31 135.94 91.03 88.39 109 78.1 96.89 68.61 115.36 45.59 117.5 45.59 99.25 68.33 111.98 78.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m170.83,96.58l-31.46,45.42-1.37-.95,30.77-44.41-13.74-18.2,12.45-4.26-9.96-28.57h.65c.38,0,.75,0,1.13.02l10.32,29.58-11.87,4.06,13.08,17.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.58 175.52 135.63 175.52 157.72 45.68 119.67 45.68 97.58 175.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "148.36 57.53 132.67 45.63 141.38 16.49 158.86 20.33 148.36 57.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m119.67,45.59c.86,2.81,6.02,17.74,19.86,18.93,15.26,1.31,18.2-18.85,18.2-18.85-.13-.03-.25-.06-.38-.08h-37.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.1,18.77v.17c0,.81-.09,1.65-.27,2.48-1.25,5.67-6.46,9.43-12.09,8.99-.53-.04-1.07-.12-1.6-.24-.64-.14-1.27-.33-1.85-.58-5.11-2.06-8.13-7.56-6.91-13.11,1.17-5.31,5.82-8.95,11.03-9.03.88,0,1.76.07,2.66.27,5.32,1.17,8.95,5.83,9.03,11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.13,32.78c0,.21,0,.42-.03.62-.34,3.11-3.53,5.5-6.67,4.81l-8.84-1.94-.31-6.66-.53-11.65,2.31.12,14.04.71v.17l.04,13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m164.13,32.78c0,.21,0,.42-.03.62-1.74,1.68-4.11,3.5-6.99,2.56-2.62-.86-4.68-3.53-5.82-5.58-2.46-4.4-1.76-9.93-1.76-9.93l.52-2.38,2.35-10.6c.88,0,1.76.07,2.66.27,5.32,1.17,8.95,5.83,9.03,11.04v.17l.04,13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m163.96,16.71s-7.41,6.82-16.77,8.1c-4,.55-7.28,1-8.56.87l2.75-9.18c1.36-6.2,7.49-10.13,13.69-8.77,4.58,1.01,8,4.65,8.89,8.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "154.02 37.46 147.19 35.96 152.94 41.3 154.02 37.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m149.44,23.95c-.45,2.03-2.46,3.32-4.49,2.87s-3.32-2.46-2.87-4.49c.45-2.03,2.46-3.32,4.49-2.87s3.32,2.46,2.87,4.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.41 29.7 159.49 29.7 159.49 29.02 160.73 29.02 160.73 26.08 161.41 26.08 161.41 29.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m157.78,33.37c-2.16,0-3.61-1.96-3.67-2.05l.55-.4s1.31,1.77,3.12,1.77v.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.71,147.27l-23.09,22.64c-1.93,1.9-5.1,1.75-6.85-.41-1.24-1.53-1.26-3.65-.29-5.31.22-.37.49-.72.81-1.04.82-.8.49-2.19-.61-2.53l-16.16-5.02-1.7-.53-.58-.18,8.57-27.6,5.59,1.73,1.81.56,2.09.65s10.93,3.4,12.56,3.9l5.8,1.8c13.12,3.9,13.78,9.64,12.06,11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.09,155.47s-3.31-.3-8.57-.83c-15.97-1.61-49.81-5.35-62.36-9.25-13.69-4.26-18.21-16.03-14.58-27.71.51-1.66,1.21-3.22,2.05-4.66,5.07-8.64,15.56-13,25.55-9.96.04.01.08.03.12.04l66.36,24.78-8.56,27.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m204.71,230.19h-111.18c-25.26,0-43.03-24.16-35.92-48.4l6.24-17.73h140.86v66.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m246.87,223.52l-31.25,87.05c-7.18-4.92-13.63-11.84-16.1-21.39-6.77-26.19,9.93-48.22-15.3-58.98-25.23-10.77-14.34-40.68-14.34-40.68l5.52-13.48c7.91-7.37,18.55-11.98,30.51-11.98.66,0,1.32.01,1.97.05,29.55,1.28,48.98,31.57,38.99,59.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m229.24,158.64l-45.67,36.38-44.13,35.17h-48.08c-5.49,0-10.6-1.2-15.16-3.31-16.06-7.47-25.18-26.38-18.76-44.59l6.41-18.22,127.88-38.5.09-.04,18.31,16.19,19.12,16.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.09 231 137.33 230.61 222.53 162.66 223.83 164.29 140.09 231"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 102.54,
    y: 230.19,
    width: 2.08,
    height: 24.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 254.22,
    width: 8.01,
    height: 110.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 95.56,
    y: 254.22,
    width: 8.01,
    height: 110.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontaktWoman);
export default __webpack_public_path__ + "static/media/kontakt-woman.113fe597084d117ed50618eeabf0a5c7.svg";
export { ForwardRef as ReactComponent };